import { AxiosResponse } from "axios";
import { doGet } from "../../Common/utils/https";
import { getRequestHeaders } from "../../Common/utils/https";
import { cloudFunctionsUrl } from "../firebase";
import { Giveaway } from "../../Common/models/giveaways";

const baseUrl = cloudFunctionsUrl;

export const getOngoingGiveaways = async (): Promise<
  AxiosResponse<{ result: Giveaway[] }>
> => {
  const url = `${baseUrl}giveaways/getOngoingGiveaways`;
  const headers = await getRequestHeaders();
  return doGet(url, headers);
};

export const getUpcomingGiveaways = async (): Promise<
  AxiosResponse<{ result: Giveaway[] }>
> => {
  const url = `${baseUrl}giveaways/getUpcomingGiveaways`;
  const headers = await getRequestHeaders();
  return doGet(url, headers);
};

export const getPastGiveaways = async (): Promise<
  AxiosResponse<{ result: Giveaway[] }>
> => {
  const url = `${baseUrl}giveaways/getPastGiveaways`;
  const headers = await getRequestHeaders();
  return doGet(url, headers);
};
